import RejectionRestrictedApproval from './rejection_restricted_approval';
import RejectionRestrictedApprovedFeedback from './rejection_restricted_approved_feedback';
import RejectionRestrictedDoNotDistributeFeedback from './rejection_restricted_dnd_feedback';

export default {
    RejectionRestrictedApproval,
    RejectionRestrictedApprovedFeedback,
    RejectionRestrictedDoNotDistributeFeedback
};



// WEBPACK FOOTER //
// ./components/content_review_workflow/rejection_restricted_path/index.js